<template>
  <div class="container mt-2">
    <v-img
      class="content"
      max-width="80%"
      :src="require('@/assets/secreth.png')"
    ></v-img>
  </div>
</template>

<script>
export default {
  name: "SecretH",
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.content {
  max-width: 60%;
}
</style>
